exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-48d0a5ef]{font-family:华文楷体;font-size:10.5pt;border-bottom:1px solid #ff4a7d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-48d0a5ef","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplier/contract/view/contract_5_2.vue
// module id = 376
// module chunks = 0